import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import consts from "../../constant";

const url = `${consts?.BackendUrl}`;


//get Support Category
export const getSupportCategory = createAsyncThunk(
    "support/getSupportCategory", // ✅ Unique action type under
    async (_, { rejectWithValue }) => {

        try {
            const response = await axios.get(`${url}/support/getSupportCategory`, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data?.message || "Failed To Get Category");
        }
    }
);


//create User Ticket
export const createUserTicket = createAsyncThunk(
    "support/createticket", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/support/createticket`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });

            if (!response?.data?.success) {
                return rejectWithValue(response?.data || "Failed To Add User Ticket");
            }

            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Add User Ticket");
        }
    }
);


export const getuserTicketList = createAsyncThunk(
    "support/support",
    async (data: any | undefined, { rejectWithValue }) => {
        try {
            const urlfull = data
                ? `${url}/support/support?search=${encodeURIComponent(data)}`
                : `${url}/support/support`;

            const response = await axios.get(urlfull, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });

            return response?.data;
        } catch (error: any) {
            return rejectWithValue(
                error.response?.data?.message || "Failed To Get Support"
            );
        }
    }
);


//User Reply Message
export const postReplyMessage = createAsyncThunk(
    "support/replymessage", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/support/replymessage`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });

            if (!response?.data?.success) {
                return rejectWithValue(response?.data || "Failed To Add User Ticket");
            }

            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Add User Ticket");
        }
    }
);


//User Ticket Close
export const postTicketClose = createAsyncThunk(
    "support/closeticket", // ✅ Unique action type under
    async (payload: any, { rejectWithValue }) => {
        try {
            const response = await axios.post(`${url}/support/closeticket`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${localStorage.getItem('crymadx')}`
                }
            });

            if (!response?.data?.success) {
                return rejectWithValue(response?.data || "Failed To Add User Ticket");
            }

            return response?.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || "Failed To Add User Ticket");
        }
    }
);



const supportSlice = createSlice({
    name: "support",
    initialState: {
        supportCategory: [],
        isLoading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            // get stake currency method
            .addCase(getSupportCategory?.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getSupportCategory.fulfilled, (state, action) => {
                state.isLoading = false;
            })
            .addCase(getSupportCategory.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action?.payload;
            })
    },
});





export default supportSlice.reducer;